import styled from 'styled-components';
export const Folder = styled.span`
  cursor: pointer;
  font-weight: 700;
  color: #98a9bc;
`;
export const Bread = styled.span`
  color: #98a9bc;
`;